module.exports = __webpack_public_path__ + "static/ring_of_x_ray_vision-c3a1f9e678d15ea1b847bfcf6d0a043c.jpeg";